import { updateConsultRequestFields, updateQualificationResponses } from '../../services/customFieldService';
import { t } from '../../utils/i18n';
import {
    appUrl,
    form,
    leadTextId,
    listDataQuestion,
    listNamePageQuestion,
    nameScreenDynamic,
    progressQuestion,
    setListDataQuestion,
    setListNamePageQuestion,
    setNameScreenDynamic,
    setProgressQuestion,
    questionnaireFields,
    questionnaireFormId,
    clearQuestionnaireContext,
} from '../../utils/variables';
import { toastError } from '../../views/components/error';
import { clearCustomFields, loadCustomFields } from '../actions/consultActions';
import { checkboxQuestionListener } from './checkboxQuestionListener';
import { dateQuestionListener } from './dateQuestionListener';
import { heightQuestionListener } from './heightQuestionListener';
import { customFeildGoBackAnimationHandler, navigate, setSessionEndStepSentForLeadId, setIsDisqualified } from './movePages';
import { numberQuestionListener } from './numberQuestionListener';
import { selectQuestionListener } from './selectQuestionListener';
import { textQuestionListener } from './textQuestionListener';
import { navigateToNextPage } from './navigationHelper';
import { evaluateDisqualifier, shouldDisqualifyNow } from '../../utils/disqualifierEvaluator';
import { navigate } from './movePages';
import { SCREEN } from '../../utils/constants';
import { updateLeadStep } from '../../services/leadServices';
import { leadInfo } from '../../utils/variables';

export function textAreaQuestonListener() {
    // check has data
    if (
        listNamePageQuestion.find((name) => name === nameScreenDynamic) &&
        listDataQuestion[nameScreenDynamic.split('--')[1]]
    ) {
        const value = document.querySelector(
            `${nameScreenDynamic} .textareaQuestion`
        );
        if (value) {
            value.value = listDataQuestion[nameScreenDynamic.split('--')[1]];
        }
        setTimeout(() => {
            const textAreaNameInput = document.querySelector(
                `${nameScreenDynamic} #textareaQuestion`
            );
            if (textAreaNameInput !== document.activeElement) {
                textAreaNameInput.focus();
            }
        }, 500);
        document
            .querySelector(`${nameScreenDynamic} .textareaContinue__btn`)
            ?.classList.remove('disabled');
        document
            .querySelector(
                `${nameScreenDynamic} .textareaContinue__btn .loading__wrapper`
            )
            ?.classList.add('hidden');
        const loaderIcon = document.querySelector(
            `${nameScreenDynamic} .loader__icon`
        );
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML(
                'beforeend',
                `<i class="ri-arrow-right-line"></i>`
            );
        }
        return;
    }

    // edit textarea
    const textAreaElement = document.querySelector(
        `${nameScreenDynamic} .textareaQuestion`
    );
    textAreaElement?.addEventListener('input', function () {
        if (
            document.querySelector(`${nameScreenDynamic} .textareaQuestion`)
                ?.value
        ) {
            document
                .querySelector(`${nameScreenDynamic} .textareaContinue__btn`)
                .classList.remove('disabled');
        } else {
            document
                .querySelector(`${nameScreenDynamic} .textareaContinue__btn`)
                .classList.add('disabled');
        }
    });

    /* On click Back button */
    document
        .querySelector(`${nameScreenDynamic} .textareaQuestionBack__btn`)
        ?.addEventListener('click', () => {
            const idx = listNamePageQuestion.findIndex(
                (l) => l === nameScreenDynamic
            );
            if (idx > 0) {
                customFeildGoBackAnimationHandler(`${nameScreenDynamic}`);
                setProgressQuestion({
                    ...progressQuestion,
                    currentQuestion: progressQuestion.currentQuestion - 1,
                    progress: (((progressQuestion.currentQuestion - 1) / progressQuestion.total) * 100)
                });
                setNameScreenDynamic(listNamePageQuestion[idx - 1]);

                if (
                    nameScreenDynamic.includes('text') &&
                    !nameScreenDynamic.includes('textarea')
                ) {
                    textQuestionListener();
                } else if (nameScreenDynamic.includes('checkbox')) {
                    checkboxQuestionListener();
                } else if (nameScreenDynamic.includes('select')) {
                    selectQuestionListener();
                } else if (nameScreenDynamic.includes('date')) {
                    dateQuestionListener();
                } else if (nameScreenDynamic.includes('textarea')) {
                    textAreaQuestonListener();
                } else if (nameScreenDynamic.includes('number')) {
                    numberQuestionListener();
                } else if (nameScreenDynamic.includes('height')) {
                    heightQuestionListener();
                }
            } else {
                customFeildGoBackAnimationHandler(`${nameScreenDynamic}`);
            }
        });

    // on click continue button
    const buttonTextAreaContinue = document.querySelector(
        `${nameScreenDynamic} .textareaContinue__btn`
    );
    buttonTextAreaContinue.addEventListener('click', async function () {
        if (!listNamePageQuestion.find((list) => list === nameScreenDynamic)) {
            listNamePageQuestion.push(nameScreenDynamic);
        }
        setListNamePageQuestion(listNamePageQuestion);
        document
            .querySelector(`${nameScreenDynamic} .textareaContinue__btn`)
            ?.classList.add('disabled');
        document
            .querySelector(
                `${nameScreenDynamic} .textareaContinue__btn .loading__wrapper`
            )
            ?.classList.remove('hidden');
        const loaderIcon = document.querySelector(
            `${nameScreenDynamic} .loader__icon`
        );
        if (loaderIcon) {
            loaderIcon.innerHTML = '';
            loaderIcon.insertAdjacentHTML(
                'beforeend',
                `<img src="${appUrl}/assets/icons/rolling.png" />`
            );
        }
        const item = nameScreenDynamic.split('--')[1];
        const textAreaVal = textAreaElement.value;
        const answersWithCurrent = { ...listDataQuestion, [item]: textAreaVal };
        listDataQuestion[item] = textAreaVal;
        setListDataQuestion(listDataQuestion);
        const fields = questionnaireFields?.length
            ? questionnaireFields
            : form?.form?.custom_fields ?? [];
        const currentField = fields.find((f) => f && f.id == item);
        const minDisqualifiers = form?.appointment_channel?.min_disqualifier_matches ?? form?.consult_min_disqualifier_matches ?? 1;
        if (currentField && evaluateDisqualifier(currentField, textAreaVal) && shouldDisqualifyNow(fields, answersWithCurrent, minDisqualifiers)) {
            try {
                const fieldLabels = {};
                const sourceFields = questionnaireFields?.length ? questionnaireFields : (form?.form?.custom_fields ?? []);
                sourceFields.forEach((f) => { if (f && f.id) fieldLabels[f.id] = (f.label || f.title || t('custom_field')); });
                const formId = questionnaireFormId ?? form?.form?.id;
                if (typeof formId === 'string' && formId.startsWith('ac-')) {
                    const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                    await updateQualificationResponses(leadTextId, acId, listDataQuestion, fieldLabels);
                } else {
                    await updateConsultRequestFields(leadTextId, listDataQuestion, fieldLabels);
                }
            } catch (_) { /* save best-effort */ }
            if (leadInfo?.id) {
                await updateLeadStep(leadInfo.id, 'disqualified', 'true');
                setSessionEndStepSentForLeadId(leadInfo.id);
            }
            document.querySelector(`${nameScreenDynamic} .textareaContinue__btn`)?.classList.remove('disabled');
            document.querySelector(`${nameScreenDynamic} .textareaContinue__btn .loading__wrapper`)?.classList.add('hidden');
            const loaderIcon = document.querySelector(`${nameScreenDynamic} .loader__icon`);
            if (loaderIcon) { loaderIcon.innerHTML = ''; loaderIcon.insertAdjacentHTML('beforeend', '<i class="ri-arrow-right-line"></i>'); }
            clearCustomFields();
            clearQuestionnaireContext();
            setIsDisqualified(true);
            navigate(SCREEN.THE_END);
            return;
        }
        const formId = questionnaireFormId ?? form?.form?.id;
        let idx = fields.findIndex(
            (custom) => custom && custom.id == nameScreenDynamic.split('--')[1]
        );
        if (idx == fields.length - 1) {
            try {
                const fieldLabels = {};
                    const sourceFields = questionnaireFields?.length ? questionnaireFields : (form?.form?.custom_fields ?? []);
                    sourceFields.forEach((f) => { if (f && f.id) fieldLabels[f.id] = (f.label || f.title || t('custom_field')); });
                    if (typeof formId === 'string' && formId.startsWith('ac-')) {
                        const acId = parseInt(formId.replace(/^ac-/, ''), 10);
                        await updateQualificationResponses(leadTextId, acId, listDataQuestion, fieldLabels);
                    } else {
                        await updateConsultRequestFields(leadTextId, listDataQuestion, fieldLabels);
                    }
                document
                    .querySelector(
                        `${nameScreenDynamic} .textareaContinue__btn`
                    )
                    ?.classList.remove('disabled');
                document
                    .querySelector(
                        `${nameScreenDynamic} .textareaContinue__btn .loading__wrapper`
                    )
                    ?.classList.add('hidden');
                const textAreaElement = document.querySelector(
                    `${nameScreenDynamic} .textareaQuestion`
                );
                const loaderIcon = document.querySelector(
                    `${nameScreenDynamic} .loader__icon`
                );
                textAreaElement.value = '';
                if (loaderIcon) {
                    loaderIcon.innerHTML = '';
                    loaderIcon.insertAdjacentHTML(
                        'beforeend',
                        `<i class="ri-arrow-right-line"></i>`
                    );
                }
                clearCustomFields();
                clearQuestionnaireContext();
                navigateToNextPage();
            } catch (error) {
                toastError(error.response?.data?.message);
            }
        } else {
            setProgressQuestion({
                ...progressQuestion,
                currentQuestion: progressQuestion.currentQuestion + 1,
                progress: (((progressQuestion.currentQuestion + 1) / progressQuestion.total) * 100)
            });
            loadCustomFields(fields[idx + 1]);
        }
    });
}
